module.exports = __webpack_public_path__ + "static/theme-editor-show-extra-links-topbar-875b5b1bf094f690cb8adf4cc652b7e8.png";